module.exports = __webpack_public_path__ + "img/logo-mark-white.788ddcd0.png";